/* eslint-disable array-bracket-newline */
/**
 * Selectable list of exchanges and chains
 */
import { useSelector } from 'react-redux';
import { enums } from '@kattana-io/common';

import Text from '../../atoms/Text';
import Image from '../../atoms/Image';

import { IStore } from '../../reducers';
import { IMobileFilterProps } from '../SearchTable/SearchTable';
import { decorateExchangeName } from '../../helpers/decorators';
import {
  SearchSelectList,
  searchCexList,
  searchDexList,
  testnetsList,
} from '../../reducers/modal_search';

import checkmark from '../../assets/images/check.svg';
import gateio from '../../assets/images/exchanges/gateio.svg';
import binance from '../../assets/images/exchanges/binance.svg';
import bybit from '../../assets/images/exchanges/bybit_small.png';
import okx from '../../assets/images/exchanges/okex.png';
import hitbtc from '../../assets/images/exchanges/hitbtc.png';
import huobi from '../../assets/images/exchanges/huobi.svg';
import kucoin from '../../assets/images/exchanges/kucoin.svg';

import './styles.scss';

const cexExchangesImageMapping: Record<string, string> = {
  binance,
  bybit,
  hitbtc,
  gateio,
  okx,
  huobi,
  kucoin,
};

const LIST: SearchSelectList = [
  ...searchCexList,
  ...searchDexList,
  ...testnetsList,
];

const MobileTickersFilter = ({ setFilterValue }: IMobileFilterProps) => {
  const exchanges = useSelector(
    (state: IStore) => state.modal_search.exchanges
  );
  const chains = useSelector((state: IStore) => state.modal_search.chains);

  const onChainClick = (item: string) => {
    if (chains.includes(item)) {
      setFilterValue!({
        items: chains.filter((i) => i !== item),
        isChain: true,
      });
    } else {
      setFilterValue!({ items: [...chains, item], isChain: true });
    }
  };

  const onExchangeClick = (item: string) => {
    if (exchanges.includes(item)) {
      setFilterValue!({ items: exchanges.filter((i) => i !== item) });
    } else {
      setFilterValue!({ items: [...exchanges, item] });
    }
  };

  return (
    <>
      {LIST.map(({ kind, item }) => {
        if (kind === enums.ETickerKind.CEX) {
          const isActive = exchanges.includes(item);
          return (
            <div
              className={`chain_exchange_option${
                isActive ? ' chain_exchange_option--active' : ''
              }`}
              key={item}
              onClick={() => onExchangeClick(item)}
            >
              <div className='chain_exchange_option__title'>
                {isActive && (
                  <div className='chain_exchange_option__title__checkmark'>
                    <Image size='m' src={checkmark} />
                  </div>
                )}
                <Text size={14} className='text--weight-500'>
                  {decorateExchangeName(item)}
                </Text>
              </div>
              <div className='chain_exchange_option__icon'>
                <Image src={cexExchangesImageMapping[item]} size='m' />
              </div>
            </div>
          );
        }
        const isActive = chains.includes(item.getSymbol());
        return (
          <div
            className={`chain_exchange_option${
              isActive ? ' chain_exchange_option--active' : ''
            }`}
            key={item.chain}
            onClick={() => onChainClick(item.getSymbol())}
          >
            <div className='chain_exchange_option__title'>
              {isActive && (
                <div className='chain_exchange_option__title__checkmark'>
                  <Image size='m' src={checkmark} />
                </div>
              )}
              <Text size={14} className='text--weight-500'>
                {item.getTitle()}
              </Text>
            </div>
            <div className='chain_exchange_option__icon'>
              <Image
                src={item.getImage()}
                size='m'
                className={`network_selector--${item.chain}`}
              />
            </div>
          </div>
        );
      })}
    </>
  );
};

export default MobileTickersFilter;
